import { BsPencil } from "react-icons/bs"
import { styles } from "./styles"
import { OnestBoldBig, OnestBoldDefault, OnestNormal, OnestSemiBoldBig } from "../../../styled/TextComponents"
import { color_grey_dark, color_grey_light, color_grey_ultra_light, color_red_default } from "../../../../constants/colors"
import { StudentInfoEditSelector } from "../studentInfoEditSelector/StudentInfoEditSelector"
import { StudentProfileInfoEdit } from "../studentProfileInfo/StudentProfileInfoEdit"
import { StudentSchedule } from "../../StudentSchedule"
import { StudentScheduleEdit } from "../studentSchedule/StudentSchedule"
import React, { Fragment, useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Config from "../../../../Config";
import { updateUser } from "../../../../store/UserSlice";
import config from "../../../../Config";
import { updateStudent } from "../../../../store/StudentSlice";
import EditIcon from "../../../icons/EditIcon"
import { useWindowDimensions } from "../../../../utils"
import { InfinitySpin } from "react-loader-spinner"
import ModalSimple from "../../ModalSimple"
import { useI18n } from "../../../../i18n/I18nProvider";

const isStudentProfileReadyForSchedule = (student) =>
    student?.studentId != null &&
    student.studentId !== -1 &&
    String(student.name || "").trim().length > 0 &&
    Number(student.age) > 0;

export const StudentImage = ({ image, addCashImage }) => {
    const { t } = useI18n();
    const student = useSelector(state => state.student);
    const dispatch = useDispatch();
    const { height: screenHeight, width: screenWidth } = useWindowDimensions();
    const isMobile = screenWidth < 768;
    const imageSize = isMobile ? 73 : 130;
    const editButtonSize = isMobile ? 24 : 30;
    const inputFile = useRef(null);
    const [isWaiting, setIsWaiting] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const [modalTitle, setModalTitle] = useState(null);

    return (
        <Fragment>
            <ModalSimple
                isOpen={!!modalContent}
                h2={modalTitle ? modalTitle : " "}
                p={modalContent}
                onClose={() => {
                    setModalContent(null);
                    setModalTitle(null);
                }}
            />
            <div style={{
                ...styles.studentImageContainer,
                width: imageSize,
                minWidth: imageSize,
                maxWidth: imageSize,
                height: imageSize,
                minHeight: imageSize,
                maxHeight: imageSize,
                flex: `0 0 ${imageSize}px`,
            }}>
                {isWaiting ?
                    <div style={{
                        ...styles.studentImage,
                        width: imageSize,
                        height: imageSize,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: color_grey_ultra_light,

                    }}>
                        <div style={{
                            width: 200,
                            height: 100,
                            marginLeft: 12,
                            marginTop: 5,
                        }}>
                            <InfinitySpin
                                size={26}
                                color={color_red_default}
                            />
                        </div>
                    </div>
                    :
                    <img
                        style={{
                            ...styles.studentImage,
                            width: imageSize,
                            minWidth: imageSize,
                            maxWidth: imageSize,
                            height: imageSize,
                            minHeight: imageSize,
                            maxHeight: imageSize,
                            display: "block",
                            flexShrink: 0,
                        }}
                        src={image ? Config.CLOUD_ADDR + "/" + image : student.image}
                        alt={"studentImage"}
                    />
                }
                {!isWaiting &&
                    <div
                        style={{ ...styles.studentImageChangeButton, width: editButtonSize, height: editButtonSize }}
                        onClick={() => { inputFile.current.click(); }}>
                        <input
                            accept="image/png, image/gif, image/jpeg" type='file' id='file' ref={inputFile} style={{ display: 'none' }}
                            onChange={(e) => {
                                if (student.studentId === -1) {
                                    setModalTitle(" ");
                                    setModalContent(t("Пожалуйста, сначала заполните профиль ученика и сохраните его"));
                                    return;
                                }
                                setIsWaiting(true);
                                let fileObj = e.target.files[0]


                                // Проверка размера файла (не больше 1024 КБ)
                                if (fileObj.size > 1024 * 1024) {
                                    setModalTitle(t("Файл слишком большой!"));
                                    setModalContent(t("Размер файла не должен превышать 1 mb. Если ваш файл больше – уменьшите через любой онлайн-сервис (например, tinypng.com) и попробуйте снова."));
                                    setIsWaiting(false);
                                    return;
                                }
                                const img = new window.Image();
                                const objectUrl = URL.createObjectURL(fileObj);
                                img.src = objectUrl;
                                console.log("fileObj", fileObj)
                                img.onload = function () {
                                    if (img.width > 1000 || img.height > 1000) {
                                        setModalTitle(t("Файл слишком большой!"));
                                        setModalContent(t("Разрешение изображения не должно превышать 1000x1000 px. Если ваш файл больше – уменьшите через любой онлайн-сервис (например, tinypng.com) и попробуйте снова."));
                                        setIsWaiting(false);
                                        URL.revokeObjectURL(objectUrl);
                                        return;
                                    }
                                    // Продолжить обработку, если все проверки пройдены

                                    const formData = new FormData();
                                    formData.append("file", fileObj, fileObj.name);

                                    const headers = { 'Content-Type': 'multipart/form-data' }

                                    axios.post(Config.BACKEND_ADDR + "/cloud/put_file", formData, { headers: headers }).then(res => {
                                        if (student?.studentId === -1) {
                                            addCashImage(res.data.file_id)
                                        } else {
                                            dispatch(updateStudent({ "image": Config.CLOUD_ADDR + "/" + res.data.file_id }))
                                            axios.patch(config.BACKEND_ADDR + "/students/", {
                                                student_id: student.studentId,
                                                image: res.data.file_id
                                            }).then(() => {
                                                dispatch(updateStudent({ "image": Config.CLOUD_ADDR + "/" + res.data.file_id }))
                                                setIsWaiting(false);
                                            }).catch((err) => {
                                                console.log(err)
                                                setModalTitle(" ");
                                                setModalContent(err.request.response.detail || t("Ошибка обновления имени изображения в профиле ученика"));
                                                setIsWaiting(false);
                                                URL.revokeObjectURL(objectUrl);
                                            })
                                        }

                                    }).catch((err) => {
                                        setModalTitle(" ");
                                        setModalContent(err.request.response.detail || t("Ошибка отправки изображения"));

                                        setIsWaiting(false);
                                        URL.revokeObjectURL(objectUrl);
                                    })
                                }
                                e.target.value = null; // Сброс значения input, чтобы можно было выбрать тот же файл снова, если нужно
                                return;
                            }}
                        />
                        <EditIcon
                            width={isMobile ? 9 : 16}
                            height={isMobile ? 9 : 16}
                            fill={color_grey_ultra_light}
                        />
                    </div>
                }
            </div>
        </Fragment>
    )
}

export const StudentName = () => {
    const { t } = useI18n();
    const { height: screenHeight, width: screenWidth } = useWindowDimensions();
    const student = useSelector(state => state.student);
    const isCompactMobile = screenWidth < 768 && screenWidth <= screenHeight;
    return (
        <div style={{
            ...styles.studentNameContainer,
            alignItems: "flex-start",
            justifyContent: "center",
            width: isCompactMobile ? 160 : "auto",
            height: isCompactMobile ? 73 : 60,
            gap: isCompactMobile ? 6 : 10,
            marginBottom: 0,
        }}>
            <OnestNormal style={{ color: color_grey_dark, fontSize: 14, fontWeight: 500 }}>
                {t("Ученик")}
            </OnestNormal>
            <OnestSemiBoldBig style={{ fontSize: 20, lineHeight: "24px" }}>
                {student.name}
            </OnestSemiBoldBig>
        </div>
    )
}


export const StudentInfo = ({ levels }) => {
    const { t } = useI18n();
    const { height: screenHeight, width: screenWidth } = useWindowDimensions();
    const isCompactMobile = screenWidth < 768 && screenWidth <= screenHeight;
    const mobileCardWidth = Math.min(330, screenWidth - 30);
    const student = useSelector((state) => state.student);

    const [currentState, setCurrentState] = useState("PROFILE");
    const [cacheImage, setCacheImage] = useState("");
    const [scheduleBlockedModalOpen, setScheduleBlockedModalOpen] = useState(false);
    const canOpenSchedule = isStudentProfileReadyForSchedule(student);

    useEffect(() => {
        if (!canOpenSchedule && currentState === "SCHEDULE") {
            setCurrentState("PROFILE");
        }
    }, [canOpenSchedule, currentState]);

    const handleStateChange = (newState) => {
        if (newState === "SCHEDULE" && !canOpenSchedule) {
            setScheduleBlockedModalOpen(true);
            return;
        }
        setCurrentState(newState);
    };

    return (
        <div
            style={{
                ...styles.studentInfoContainer,
                width: screenWidth > 1155 ? 480 : isCompactMobile ? mobileCardWidth : "100%",
                padding: isCompactMobile ? 20 : 30,
                margin: isCompactMobile ? "0 auto" : undefined,

            }}>
            <ModalSimple
                isOpen={scheduleBlockedModalOpen}
                h2={t("Сначала сохраните профиль")}
                p={t("Чтобы открыть расписание, заполните имя и возраст ученика и нажмите «Сохранить».")}
                onClose={() => setScheduleBlockedModalOpen(false)}
            />
            <div style={{
                ...styles.studentImageNameContainer,
                width: screenWidth > 1155 ? 420 : "100%",
                flexDirection: "row",
                gap: isCompactMobile ? 17 : 25,
                justifyContent: "flex-start",
                alignItems: "center",
                alignSelf: isCompactMobile ? "center" : "stretch",
            }}>
                <StudentImage addCashImage={setCacheImage} image={cacheImage} />
                <StudentName />
            </div>
            <>
                <StudentInfoEditSelector
                    currentState={currentState}
                    stateChangeCallback={handleStateChange}
                    scheduleDisabled={!canOpenSchedule}
                />
                {currentState === "PROFILE" ?
                    <StudentProfileInfoEdit levels={levels} addCashImage={setCacheImage} image={cacheImage} />
                    :
                    <StudentScheduleEdit />
                }
            </>
        </div>
    )
}